import { useState } from 'react'
import TraineesList from './TraineesList';
import { Trainee } from 'src/redux/types/_trainee.type';
import EditTrainee from './EditTrainee';


type View = "list" | "edit";

const TraineeDashboard = () => {
  
    const [view, setView] = useState<View>("list");
    const [trainee, setTrainee] = useState<Trainee>();

    const defaultView = () => {
      setView("list");
    };

    const editTrainee = (trainee: Trainee) => {
      setView("edit");
      setTrainee(trainee)
    };

    const renderView = () => {
      switch (view) {
        case "list":
          return <TraineesList  editTrainee={editTrainee}/>;
        case "edit":
          return <EditTrainee  defaultView={defaultView} trainee={trainee!}/>;
      }
    };
  
  return (
      <div>{renderView()}</div>
  )
}

export default TraineeDashboard